"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryReward = void 0;
const HistoryRewardsList_1 = require("./HistoryRewardsList");
class HistoryReward {
    constructor(data) {
        this.date_created = data.date_created;
        this.date_fulfilled = data.date_fulfilled;
        this.total_points_redeemed = data.total_points_redeemed;
        this.ending_balance = data.ending_balance;
        this.quantity = data.quantity;
        this.shipping_first_name = data.shipping_first_name;
        this.shipping_last_name = data.shipping_last_name;
        this.shipping_street_address_1 = data.shipping_street_address_1;
        this.shipping_street_address_2 = data.shipping_street_address_2;
        this.shipping_country = data.shipping_country;
        this.shipping_state = data.shipping_state;
        this.shipping_city = data.shipping_city;
        this.shipping_zip = data.shipping_zip;
        this.shipping_phone_number = data.shipping_phone_number;
        this.description = data.description;
        this.tracking_number = data.tracking_number;
        this.codes = data.codes;
        this.digital_download = data.digital_download;
        this.reward_id = data.reward_id;
        this.reward_title = data.reward_title;
        this.category_id = data.category_id;
        this.group_id = data.group_id;
        this.image = data.image;
        this.extra_data = data.extra_data;
        this.dateCreated = null;
    }
}
exports.HistoryReward = HistoryReward;
HistoryReward.JsonToRewards = (data) => {
    const rewardsList = new HistoryRewardsList_1.HistoryRewardsList();
    data.forEach(reward => rewardsList.push(HistoryReward.JsonToReward(reward)));
    return rewardsList.getDateStartSorted();
};
HistoryReward.JsonToReward = (data) => new HistoryReward(data);
//# sourceMappingURL=HistoryReward.js.map